$(document).ready(function(){
    $('.category-slider').slick({
      dots: false,
      infinite: false,
      speed: 600,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          }
      ]
    });
    $(".category-slider").show();  // add this line to reveal the slides after calling slick
  });

  $(document).ready(function(){
    $('.client-slider').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  });